var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fae5ff",
    viewBox: "0.5 0.5 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 .5C7.45.5.5 7.45.5 16S7.45 31.5 16 31.5 31.5 24.55 31.5 16 24.55.5 16 .5m8.71 17H17.5v7.21c0 .82-.67 1.5-1.5 1.5s-1.5-.68-1.5-1.5V17.5H7.29c-.82 0-1.5-.67-1.5-1.5s.68-1.5 1.5-1.5h7.21V7.29c0-.82.67-1.5 1.5-1.5s1.5.68 1.5 1.5v7.21h7.21c.82 0 1.5.67 1.5 1.5s-.68 1.5-1.5 1.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconPrimary);
export default __webpack_public_path__ + "static/media/plus_icon_primary.56371f12d69a89bc5d122dcbc27d0343.svg";
export { ForwardRef as ReactComponent };